import {useEffect} from 'react';

import {NavigationType, useBlocker} from 'react-router-dom';

import {OnboardingRoutes} from '../pages/models/constants/OnboardingRouteConstants';

const isOnboardingPath = (pathname: string): boolean =>
  pathname === OnboardingRoutes.ROOT ||
  pathname.startsWith(`${OnboardingRoutes.ROOT}/`);

/**
 * Blocks native browser Back/Forward navigation (history POP) while the user
 * is under `/onboarding`, regardless of where it would land — including
 * moving between onboarding steps. React Router's own navigation
 * (Link/navigate PUSH/REPLACE, e.g. Next/Continue buttons) is left untouched.
 * Mount this only for as long as the current route is under `/onboarding`
 * (e.g. from the onboarding layout) so protection is removed automatically
 * once the user leaves the flow.
 */
const useBlockOnboardingBrowserNavigation = (): void => {
  const blocker = useBlocker(
    ({currentLocation, historyAction}) =>
      historyAction === NavigationType.Pop &&
      isOnboardingPath(currentLocation.pathname),
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  }, [blocker]);
};

export default useBlockOnboardingBrowserNavigation;
